<script>
  import formatDateMixin from '@mixins/FormatDateMixin.vue'

  export default {
    mixins: [formatDateMixin],
    props: {
      date: {
        type: String,
        default: null,
      },
      isSqlDate: {
        type: Boolean,
        default: false,
      },
      format: {
        type: String,
        default: 'yyyy-MM-dd',
      },
    },
    computed: {
      formattedDate () {
        if (this.isSqlDate){
          return this.formatSQLTimestamp(this.date)
        }
        return this.formatDate(this.date, this.format);
      },
    },
  }
</script>

<template>
  <span>{{ formattedDate }}</span>
</template>
